import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory, useParams, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import CurrencyInput from "react-currency-input";
import { URLBunge } from "./Componentes/Config";
import Button from "@material-ui/core/Button";
import {
  LogAcesso,
  AlertForm,
  AlertRedirect,
  MascaraCNPJ,
  DecimalReal,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Swal from "sweetalert2";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  BtFiltroMesAtivo,
  BtFiltroMes,
  ItemListaBusca,
  BgModal,
  ModalEvento,
  TextoDescPesquisa,
  CampoFormCadastro,
  BtFiltrar,
  ListaFiltro,
  ItemListaAtendimentos,
  SolicitanteCliente,
  TipoAtendimento,
  BtFecharAtendimento,
  RespostaForm,
  BtVerRelatorioCompleto,
  ListaFiltroTecnicos,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
} from "./Estilos";

import IcoBusca from "./Images/ico_search_branco.png";
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaFormularioRequisicoes(props) {
  const location = useLocation();
  const history = useHistory();
  const [Loading, setLoading] = useState(true);
  const [diaSelecionado, setDiaSelecionado] = useState(location.state.dia);
  const [mesSelecionado, setMesSelecionado] = useState(location.state.mes);
  const [anoSelecionado, setAnoSelecionado] = useState(location.state.ano);
  const [TextoCarregando, setTextoCarregando] = useState("Carregando...");
  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [CPFUser, setCPFUser] = useState(localStorage.getItem("c_cpf"));
  const TipoSelecionadoInput = useRef();
  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [TipoSelecionado2, setTipoSelecionado2] = useState(0);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  useEffect(() => {
    if (Token === null) {
      history.push({ pathname: "/", state: {} });
    } else {
      LogAcesso(Token, "Academia - Requisições de Atendimento - Vendedor");
    }
    setTimeout(() => {
      console.log(ListaStatus);
    }, 1000);
  }, []);

  const [ListaRequisicoes, setListaRequisicoes] = useState([]);
  const [ListaStatus, setListaStatus] = useState([]);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${URLBunge}/api/Requisicoes/ListaStatus`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        ListarRequisicoes(result.listaStatus[0].idStatus);
        setTipoSelecionado2(result.listaStatus[0].idStatus);

        for (let i = 0; i < result.listaStatus.length; i = i + 1) {
          if (result.listaStatus[i].descricao == "Encaminhada p/ Coordenador") {
            setListaStatus((ListaStatus) => [
              ...ListaStatus,
              {
                value: result.listaStatus[i].idStatus,
                label: "Encaminhada para o Coordenador",
              },
            ]);
          } else if (
            result.listaStatus[i].descricao == "Encaminhada p/ Técnico"
          ) {
            setListaStatus((ListaStatus) => [
              ...ListaStatus,
              {
                value: result.listaStatus[i].idStatus,
                label: "Encaminhada para o Técnico",
              },
            ]);
          } else {
            setListaStatus((ListaStatus) => [
              ...ListaStatus,
              {
                value: result.listaStatus[i].idStatus,
                label: result.listaStatus[i].descricao,
              },
            ]);
          }
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  function ListarRequisicoes(item) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${URLBunge}/api/Requisicoes/ListarRequisicoesDetalhada/?StatusId=${item}&Dia=${diaSelecionado}&Mes=${mesSelecionado}&Ano=${anoSelecionado}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("result.listaRequisicoes", result.listaRequisicoes);

        for (let i = 0; i < result.listaRequisicoes.length; i = i + 1) {
          setListaRequisicoes((ListaStatus) => [
            ...ListaStatus,
            {
              ...result.listaRequisicoes[i],
              dataFiltro: result.listaRequisicoes[i].dataVisita.substr(0, 10),
            },
          ]);
        }

        // setListaRequisicoes(result.listaRequisicoes);
        setLoading(false);
        setTextoCarregando("Nenhum registro encontrado.");
      })
      .catch((error) => console.log("error", error));
  }

  function MudaLista(Tipo) {
    setTipoSelecionado2(Tipo);
    if (Tipo === 0) {
      LogAcesso(Token, "Academia - Requisições de Atendimento - ABERTOS");
    }
    if (Tipo === 1) {
      LogAcesso(Token, "Academia - Requisições de Atendimento - EM ANDAMENTO");
    }
    if (Tipo === 2) {
      LogAcesso(Token, "Academia - Requisições de Atendimento - FINALIZADOS");
    }
  }

  function MudaFiltro() {
    setTextoCarregando("Carregando...");
    setListaRequisicoes([]);
    if (TipoSelecionado === 0) {
      MudaLista(1);
      ListarRequisicoes(1);
    } else {
      MudaLista(TipoSelecionado);
      ListarRequisicoes(TipoSelecionado);
    }
    setLoading(true);
  }

  function FinalizarRequisicao(idRequisicao) {
    history.push({
      pathname: "/AcademiaFinalizarRequisicao",
      state: {
        idRequisicao: idRequisicao,
      },
    });
    setTimeout(() => {
      setListaRequisicoes([]);
    }, 300);
  }

  function CancelarAtendimento(id) {
    Swal.fire({
      icon: "info",
      title: "Tem certeza?",
      text: "A requisição será excluída de forma definitiva.",
      confirmButtonText: "Confirmar",
      allowOutsideClick: false,
      showDenyButton: true,
      denyButtonText: "Cancelar",
    }).then(function (tipo) {
      if (tipo.isConfirmed) {
        ConfirmarCancelamento(id);
      }
    });
  }

  function ConfirmarCancelamento(id) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      idRequisicao: id,
      statusAtendimento: 5,
    });
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(`${URLBunge}/api/Requisicoes/EditarRequisicoes`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.sucesso === true) {
          Swal.fire({
            icon: "success",
            title: "Requisição cancelada!",
            text: result.mensagem,
          }).then(function () {
            setListaRequisicoes([]);
            ListarRequisicoes(TipoSelecionado2);
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Algo deu errado!",
            text: result.mensagem,
          });
        }
      })
      .catch((error) => console.log("error", error));
  }

  function EncaminhaAtendimento(
    idRequisicao,
    solicitante,
    cliente,
    tipoAtendimento,
    detalhes,
    produto,
    dataVisita,
    potencialCompra,
    cnpj,
    sap,
    rua,
    numero,
    cep,
    bairro,
    cidade,
    uf
  ) {
    history.push({
      pathname: "/AcademiaFormularioEncaminhaRequisicao",
      state: {
        idRequisicao: idRequisicao,
        solicitante: solicitante,
        cliente: cliente,
        tipoAtendimento: tipoAtendimento,
        detalhes: detalhes,
        produto: produto,
        dataVisita: dataVisita,
        potencialCompra: potencialCompra,
        cnpj: cnpj,
        sap: sap,
        rua: rua,
        numero: numero,
        cep: cep,
        bairro: bairro,
        cidade: cidade,
        uf: uf,
      },
    });
    setTimeout(() => {
      setListaRequisicoes([]); /*setListaStatus([])*/
    }, 300);
  }

  function EditarRequisicao(item) {
    history.push({
      pathname: "/EditarRequisicao",
      state: {
        item,
      },
    });
    setTimeout(() => {
      setListaRequisicoes([]); /*setListaStatus([])*/
    }, 300);
  }

  const renderListaRequisicoes = (item, index) => {
    console.log("***", props.c_token);
    return (
      <>
        <ItemListaAtendimentos key={index}>
          {item.tipoUrgencia !== null ? (
            <>
              <SolicitanteCliente>Urgência do atendimento:</SolicitanteCliente>

              <Button
                style={{
                  backgroundColor:
                    item.tipoUrgencia == "Amarelo"
                      ? "yellow"
                      : item.tipoUrgencia == "Verde"
                      ? "green"
                      : "red",
                  marginBottom: 5,
                  width: "100%",
                  color: "#000000",
                }}
              >
                {item.tipoUrgencia == "Amarelo"
                  ? "Moderado"
                  : item.tipoUrgencia == "Verde"
                  ? "Sem urgência"
                  : "Crítico"}
              </Button>
            </>
          ) : null}
          {TipoSelecionado2 !== 1 ? (
            <SolicitanteCliente>
              {" "}
              Técnico: <div>{item.nomeTecnico}</div>{" "}
            </SolicitanteCliente>
          ) : null}
          <SolicitanteCliente>
            {" "}
            Solicitante: <div>{item.solicitante}</div>{" "}
          </SolicitanteCliente>
          <SolicitanteCliente>
            {" "}
            Cliente: <div>{item.cliente}</div>
            <div>{MascaraCNPJ(item.cnpj)}</div>{" "}
          </SolicitanteCliente>

          <TipoAtendimento>
            {" "}
            Endereço:{" "}
            <div>
              {item.rua}, {item.numero}
              <br />
              {item.bairro}, {item.cidade}, {item.uf}
              <br />
              {item.cep}
            </div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Data da visita:{" "}
            <div>
              {item.dataVisita.substr(8, 2)}/{item.dataVisita.substr(5, 2)}/
              {item.dataVisita.substr(0, 4)} - {item.dataVisita.substr(11, 2)}:
              {item.dataVisita.substr(14, 2)}
            </div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Tipo de atendimento: <div>{item.tipoAtendimento}</div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Produto: <div>{item.produto}</div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Potencial de compra: <div>{item.potencialCompra} KG</div>{" "}
          </TipoAtendimento>
          {item.telefoneVendedor && (
            <>
              <TipoAtendimento>
                {" "}
                Telefone do Vendedor: <div>{item.telefoneVendedor} </div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Telefone do Cliente: <div>{item.telefoneCliente} </div>{" "}
              </TipoAtendimento>
            </>
          )}

          {TipoSelecionado2 == 1 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <BtFecharAtendimento
                onClick={() =>
                  EncaminhaAtendimento(
                    item.idRequisicao,
                    item.solicitante,
                    item.cliente,
                    item.tipoAtendimento,
                    item.detalhes,
                    item.produto,
                    item.dataVisita,
                    item.potencialCompra,
                    item.cnpj,
                    item.sap,
                    item.rua,
                    item.numero,
                    item.cep,
                    item.bairro,
                    item.cidade,
                    item.uf
                  )
                }
              >
                ENCAMINHAR PARA O TÉCNICO
              </BtFecharAtendimento>
              <BtFecharAtendimento
                onClick={() => CancelarAtendimento(item.idRequisicao)}
                style={{ marginLeft: "20px", backgroundColor: "#ca2931" }}
              >
                CANCELAR
              </BtFecharAtendimento>
            </div>
          ) : null}

          {Number(TipoSelecionado2) === 2 && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <BtFecharAtendimento
                style={{ width: 150 }}
                onClick={() => EditarRequisicao(item)}
              >
                EDITAR
              </BtFecharAtendimento>
              <BtFecharAtendimento
                onClick={() => CancelarAtendimento(item.idRequisicao)}
                style={{ marginLeft: "20px", backgroundColor: "#ca2931" }}
              >
                CANCELAR
              </BtFecharAtendimento>
            </div>
          )}

          {TipoSelecionado2 == 3 ? (
            <>
              {item.checkIn !== null ? (
                <TipoAtendimento>
                  {" "}
                  Check-in:{" "}
                  <div>
                    {item.checkIn.substr(8, 2)}/{item.checkIn.substr(5, 2)}/
                    {item.checkIn.substr(0, 4)} - {item.checkIn.substr(11, 2)}:
                    {item.checkIn.substr(14, 2)}
                  </div>{" "}
                </TipoAtendimento>
              ) : null}
              {item.checkOut !== null ? (
                <TipoAtendimento>
                  {" "}
                  Check-out:{" "}
                  <div>
                    {item.checkOut.substr(8, 2)}/{item.checkOut.substr(5, 2)}/
                    {item.checkOut.substr(0, 4)} - {item.checkOut.substr(11, 2)}
                    :{item.checkOut.substr(14, 2)}
                  </div>{" "}
                </TipoAtendimento>
              ) : null}

              <TipoAtendimento>
                {" "}
                Detalhes: <div>{item.detalhes}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Observação: <div>{item.observacao}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Pessoas treinadas: <div>{item.pessoasTreinadas}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Bonificação:{" "}
                <div>{item.bonificacao === true ? "SIM" : "NÃO"}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Gastos:
                <div>
                  Insumos: {DecimalReal(item.gastosInsumo)}
                  <br />
                  Produtos internos: {DecimalReal(item.gastosProdutosInternos)}
                  <br />
                  Deslocamento: {DecimalReal(item.gastosDeslocamento)}
                  <br />
                  Alimentação: {DecimalReal(item.gastosAlimentacao)}
                  <br />
                  Hospedagem: {DecimalReal(item.gastosHospedagem)}
                  <br />
                  Outros: {DecimalReal(item.gastosDiversos)}
                  <br />
                  TOTAL:{" "}
                  {DecimalReal(
                    item.gastosProdutosInternos +
                      item.gastosDeslocamento +
                      item.gastosAlimentacao +
                      item.gastosHospedagem +
                      item.gastosDiversos
                  )}
                </div>
              </TipoAtendimento>

              {item.caminhoFoto !== "" ? (
                <>
                  <img
                    src={`https://www.plataformaomnion.com.br/UploadsImagens/AppBunge/Fotos/${item.caminhoFoto}`}
                  />
                  <br />
                  <br />
                </>
              ) : null}
            </>
          ) : null}
        </ItemListaAtendimentos>
      </>
    );
  };

  function PegaTecnicos() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/ListarTecnicos`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result)

        for (let i = 0; i < result.listaTecnicos.length; i = i + 1) {
          setListaTecnicos((ListaTecnicos) => [
            ...ListaTecnicos,
            {
              value: result.listaTecnicos[i].id,
              label: result.listaTecnicos[i].nome,
            },
          ]);
        }
      })
      .catch((error) => console.log("error", error));
  }
  useEffect(() => {
    PegaTecnicos();
  }, []);

  const [ListaTecnicos, setListaTecnicos] = useState([]);

  const [TecnicoSelecionado, setTecnicoSelecionado] = useState(0);

  useEffect(() => {
    console.log(
      ListaRequisicoes.filter(function (arr) {
        return arr.tecnicoId == TecnicoSelecionado;
      })
    );
  }, [TecnicoSelecionado]);

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Requisições de Atendimento</TitNoticias>
            <Clear />

            <BtVoltar
              onClick={() =>
                history.push({
                  pathname: "/AcademiaFormularioCalendario",
                  state: {},
                })
              }
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>
            <Clear />

            <DivBtsNoticiaNovidades style={{ marginBottom: 0, marginTop: 20 }}>
              <BtNoticiaNovidades
                style={{ width: 210 }}
                onClick={() =>
                  history.push({
                    pathname: "/AcademiaFormularioAtendimento",
                    state: {},
                  })
                }
              >
                NOVO ATENDIMENTO
              </BtNoticiaNovidades>
              <BtNoticiaNovidades
                style={{ width: 210 }}
                onClick={() =>
                  history.push({
                    pathname: "/AcademiaFormularioListaTecnico",
                    state: {},
                  })
                }
              >
                VISÃO TÉCNICO
              </BtNoticiaNovidades>
            </DivBtsNoticiaNovidades>
            <Clear />

            <br />
            <TextoDescPesquisa>
              Lista de requisições de atendimento: {diaSelecionado}/
              {mesSelecionado}/{anoSelecionado}
            </TextoDescPesquisa>
            <Clear />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ListaFiltro>
                <select
                  name={"c_estado"}
                  id={"c_estado"}
                  ref={register}
                  onChange={(event) => setTipoSelecionado(event.target.value)}
                >
                  {/* <option value={0} disabled selected>Selecione</option> */}
                  {ListaStatus.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <option value={item.value}>{item.label}</option>{" "}
                      </>
                    );
                  })}
                </select>
              </ListaFiltro>

              <BtFiltrar onClick={() => MudaFiltro()}>Filtrar</BtFiltrar>
            </div>

            <Clear />

            {TipoSelecionado2 != 1 ? (
              <div
                style={{
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "100%" }}>
                  {ListaStatus.length > 0 ? (
                    <ListaFiltroTecnicos>
                      <select
                        name={"c_estado"}
                        id={"c_estado"}
                        ref={register}
                        onChange={(event) =>
                          setTecnicoSelecionado(event.target.value)
                        }
                      >
                        <option value={0} disabled selected>
                          Selecione o técnico
                        </option>
                        {ListaTecnicos.map((item, index) => {
                          return (
                            <>
                              {" "}
                              <option value={item.value}>
                                {item.label}
                              </option>{" "}
                            </>
                          );
                        })}
                      </select>
                    </ListaFiltroTecnicos>
                  ) : null}
                </div>
              </div>
            ) : null}

            <Clear />
            <br />

            <div style={{ flex: 1 }}>
              {ListaRequisicoes.length == 0 ? (
                <div>{TextoCarregando}</div>
              ) : TipoSelecionado2 !== 1 ? (
                TecnicoSelecionado !== 0 ? (
                  ListaRequisicoes.filter(function (arr) {
                    return arr.tecnicoId == TecnicoSelecionado;
                  }).length > 0 ? (
                    ListaRequisicoes.filter(function (arr) {
                      return arr.tecnicoId == TecnicoSelecionado;
                    }).map((item, key) => {
                      return renderListaRequisicoes(item, key);
                    })
                  ) : (
                    <div>Nenhum registro encontrado.</div>
                  )
                ) : (
                  ListaRequisicoes.map((item, key) => {
                    return renderListaRequisicoes(item, key);
                  })
                )
              ) : (
                ListaRequisicoes.map((item, key) => {
                  return renderListaRequisicoes(item, key);
                })
              )}
            </div>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default AcademiaFormularioRequisicoes;
